<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="all_page_border">

        <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

        <div class="financial-summary-notice">
          统计口径：消费按服务端入账日，撤销按服务端撤销日；同日撤销不计消费成功。
        </div>

        <!-- 时间段切换按钮组 -->
        <div class="time-period-controls" style="margin-bottom: 16px;">
          <el-button v-for="(period, index) in (users[0] && users[0].SummaryList) || []" :key="index"
            :type="activePeriod === index ? 'primary' : 'default'" @click="handlePeriodClick(index)">
            {{ period.DepartmentName }}
          </el-button>
        </div>

        <!-- 列表 - 修改为只显示当前选中的时间段 -->
                <el-table v-loading="listLoading" :data="users">
          <!-- 基础信息列 -->

          <el-table-column prop="DepartmentName" label="部门" width header-align="center"
            align="center"></el-table-column>
          <el-table-column prop="TerminalName" label="终端名称" width header-align="center"
            align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.TerminalName }}</span>
              <el-tag v-if="scope.row.IsTerminalDeleted" class="terminal-deleted-tag" size="mini" type="danger" effect="plain">已删除</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="DeviceSerialNo" label="终端序列号" width header-align="center"
            align="center"></el-table-column>
          <el-table-column prop="InstallAddress" label="安装位置" width header-align="center"
            align="center"></el-table-column>

          <!-- 只显示当前选中的时间段数据 -->
          <el-table-column v-if="activePeriodData" :label="activePeriodData.DepartmentName" header-align="center">

            <el-table-column prop="TotalCount" label="消费总笔数" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].TotalCount }}</template>
            </el-table-column>

            <el-table-column prop="TotalMoney" label="消费总金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].TotalMoney.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="DiscountMoney" label="优惠金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].DiscountMoney.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="PayMoney" label="实际支付金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].PayMoney.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="RevokeCount" label="撤销笔数" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].RevokeCount }}</template>
            </el-table-column>
            <el-table-column prop="RevokeMoney" label="撤销金额" width header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.SummaryList[activePeriod].RevokeMoney.toFixed(2) }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <!-- 工具条 -->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
            style="float: right"></el-pagination>
        </el-col>
      </div>

    </section>

    <!-- 自定义表头选择对话框 -->
    <el-dialog title="选择导出字段" :visible.sync="columnSelectVisible" width="700px" :close-on-click-modal="false">
      <div class="column-select-container">
        <div class="column-section">
          <h4 style="margin-bottom: 10px;">基础信息</h4>
          <el-checkbox-group v-model="selectedBaseColumns" style="display: flex; flex-wrap: wrap;">
            <el-checkbox v-for="(label, field) in baseColumns" :key="field" :label="field"
              style="width: 100%; margin-bottom: 10px;">{{ label }}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="column-section">
          <h4 style="margin-bottom: 10px;">统计指标</h4>
          <el-checkbox-group v-model="selectedMetricColumns" style="display: flex; flex-wrap: wrap;">
            <el-checkbox v-for="(label, field) in metricColumns" :key="field" :label="field"
              style="width: 100%; margin-bottom: 10px;">{{ label }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="columnSelectVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmColumnSelection">确定</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getTerminalConsumptionSummary, exportTerminalConsumptionSummary, exportTerminalConsumptionSummaryWithInstallAddressTotal } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '终端号',
          key: 'deviceSerialNo',
          width: '160px'
        }, {
          label: '日期',
          key: 'dateRange',
          type: 'daterange',
          width: '220px',
          pickerOptions: {
            shortcuts: [
              { text: '今天', onClick(picker) { const d = new Date(); picker.$emit('pick', [d, d]); } },
              { text: '近7天', onClick(picker) { const d = new Date(); const d2 = new Date(); d2.setDate(d.getDate() - 6); picker.$emit('pick', [d2, d]); } },
              { text: '近30天', onClick(picker) { const d = new Date(); const d2 = new Date(); d2.setDate(d.getDate() - 29); picker.$emit('pick', [d2, d]); } }
            ]
          }
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",
      historyData: [],
      historyDataTotal: 0,
      historyDataPage: 1,
      historyUserId: 0,
      multipleSelection: [],

      refundDialogVisible: false,
      refundData: [],
      refundDataTotal: 0,
      refundDataPage: 1,
      activePeriod: 0, // 当前选中的时间段索引
      activePeriodData: null, // 当前选中的时间段数据

      // 字段名与表头映射
      baseColumns: {
        'DeviceSerialNo': '终端序列号',
        'TerminalName': '终端名称',
        'DepartmentName': '部门名称',
        'InstallAddress': '安装位置'
      },
      metricColumns: {
        'TotalCount': '消费笔数',
        'TotalMoney': '消费金额',
        'DiscountMoney': '补贴金额',
        'PayMoney': '实际支付金额',
        'RevokeCount': '撤销笔数',
        'RevokeMoney': '撤销金额'
      },

      // 选中的字段
      selectedBaseColumns: ['InstallAddress'], // 默认选中所有基础字段
      selectedMetricColumns: ['TotalCount', 'DiscountMoney', 'PayMoney'], // 默认选中所有指标字段

      // 对话框显示状态
      columnSelectVisible: false,

      // 保存当前的导出参数
      currentExportParams: null

    };
  },
  computed: {
  },
  methods: {
    // 时间段切换按钮点击事件
    handlePeriodClick(index) {
      this.activePeriod = index;
      this.activePeriodData = (this.users[0] && this.users[0].SummaryList[index]) || null;
    },

    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },
    callFunction(item) {
      this.currentDate = item.search.dateRange || "";
      let filters = { ...item.search };

      // 处理日期范围：dateRange -> date + endDate
      if (filters.dateRange && Array.isArray(filters.dateRange)) {
        filters.date = filters.dateRange[0];
        filters.endDate = filters.dateRange[1];
        delete filters.dateRange;
      }

      if (typeof item.search == 'object') {
        this.filters = filters;
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    // 获取用户列表 - 初始化时设置默认显示的时间段
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters
      };
      this.listLoading = true;
      getTerminalConsumptionSummary(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        // 初始化默认显示第一个时间段
        if (this.users.length > 0 && this.users[0].SummaryList && this.users[0].SummaryList.length > 0) {
          this.activePeriod = 0;
          this.activePeriodData = this.users[0].SummaryList[0];
        }
        this.listLoading = false;
      });
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters
        };

        var fileName = "终端消费汇总报表";
        const response = await exportTerminalConsumptionSummary(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
        this.$message({
          message: "导出失败",
          type: "error",
        });
      }
    },

    // 确认字段选择并开始导出
    confirmColumnSelection() {
      this.columnSelectVisible = false;
      this.exportSelectedColumns();
    },

    // 修改导出方法
    async exportExcelByAddress() {
      try {
        // 保存当前导出参数
        this.currentExportParams = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters
        };

        // 打开字段选择对话框
        this.columnSelectVisible = true;
      } catch (error) {
        console.error('导出准备失败:', error);
        this.$message({
          message: "导出失败",
          type: "error",
        });
      }
    },

    async exportSelectedColumns() {
      try {
        // 构建导出参数，包含选中的字段信息
        const exportParams = {
          ...this.currentExportParams,
          baseColumns: this.selectedBaseColumns.join(','),
          metrics: this.selectedMetricColumns.join(',')
        };

        var fileName = "终端消费汇总报表";
        const response = await exportTerminalConsumptionSummaryWithInstallAddressTotal(exportParams);

        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }

        // 处理导出数据
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
        this.$message({
          message: "导出失败",
          type: "error",
        });
      }
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

/* 搜索区域美化样式 */
.dp-right .all_page_border :deep(.toolbar) {
  margin-bottom: 12px;
  padding: 10px 16px;
}

.dp-right .all_page_border :deep(.toolbar .el-form--inline .el-form-item) {
  margin-bottom: 0 !important;
  margin-right: 16px !important;
}

.dp-right .all_page_border :deep(.toolbar .el-form--inline .el-form-item__label) {
  font-weight: 500;
  color: #606266;
  padding-right: 8px;
}

.dp-right .all_page_border :deep(.toolbar .el-button) {
  margin-left: 8px;
}

.financial-summary-notice {
  margin: 0 0 12px;
  padding: 8px 12px;
  border-left: 3px solid var(--btn-primary, #2563eb);
  background: #ecf5ff;
  color: #606266;
  font-size: 13px;
  line-height: 20px;
}

.terminal-deleted-tag {
  margin-left: 8px;
  vertical-align: middle;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.column-select-container {
  display: flex;
  justify-content: space-between;
}

.column-section {
  width: 48%;
}
</style>
